import { useState } from "react";
import classNames from "classnames";

import useQueryParams from "@shared/hooks/useQueryParams";
import { FESTIVAL_SORT } from "@features/landing/types";
import { sortItems } from "@features/landing/helpers/constants/constants";

const FestivalCardsSort = () => {
  const { setParam, removeParamByKey, getParam } = useQueryParams();
  const [sort, setSort] = useState<FESTIVAL_SORT>(
    (getParam("sort") as FESTIVAL_SORT) || FESTIVAL_SORT.MOST_POPULAR
  );

  const handleClick = (id: FESTIVAL_SORT) => {
    setSort(id);
    removeParamByKey("sort");
    setParam({ key: "sort", value: id, redirect: true });
  };

  return (
    <div className="mb-8 md:flex md:items-center">
      <span className="hidden md:block ml-6 text-sm text-fds-secondary font-medium">
        مرتب‌سازی بر اساس:
      </span>
      <ul className="flex bg-fds-brand-light w-full max-w-80 h-10 p-0.5 gap-1 rounded">
        {sortItems.map(({ id, label }) => {
          const isActive = id === sort;
          return (
            <li
              className={classNames(
                "w-1/2 h-full flex items-center justify-center text-sm text-fds-primary shadow-fds-primary transition-all ease-in-out duration-300",
                !isActive && "cursor-pointer",
                { "bg-white rounded": isActive }
              )}
              key={id}
              onClick={!isActive ? () => handleClick(id) : undefined}
            >
              {label}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FestivalCardsSort;
